import { BasketMarketOfferEntity } from '@genial/services';
import { Utils } from '@genial/utils';

import { messageError } from '../constants';

import { baseNormalization, normalizeCustomerBasketOffersData } from '.';

const getDirectTreasuryBuyingDetails = (
  item: ReturnType<typeof normalizeCustomerBasketOffersData>[number]
) => {
  return [
    {
      label: 'Rentabilidade',
      value: `${item.offer.rateIncome} + ${Utils.Mask.Percentage(item.offer.purchaseRate)}`,
    },
    {
      label: item.offer.productRisk?.formatRisk ?? messageError,
      value: item.offer.productRisk.risk ?? messageError,
      type: 'risk',
    },
    {
      label: 'Vencimento',
      value: Utils.Mask.DateFormat((item.offer.maturityDate || '') as Date, 'dd/MM/yyyy'),
    },
    { label: 'Juros', value: item.offer.periodicityRate ?? messageError },
  ];
};

const getDirectTreasurySellingDetails = (
  item: ReturnType<typeof normalizeCustomerBasketOffersData>[number]
) => {
  return [
    {
      label: 'Quantidade',
      value: item.requestedQuantity,
    },
    {
      label: 'Valor bruto solicitado',
      value: item.requestedAmountFormatted,
    },
    {
      label: 'Previsão de liquidação*:',
      value: item?.redemptionDate
        ? Utils.Mask.DateFormat(item?.redemptionDate, 'dd/MM/yyyy')
        : messageError,
    },
  ];
};

export const normalizeCustomerBasketOffersTreasury = (data?: BasketMarketOfferEntity[]) => {
  if (!data) {
    return [];
  }

  const treasuryData = data.find((item) => item.marketType === 'Treasury');

  if (!treasuryData) {
    return [];
  }

  const treasuryNormalizedData = normalizeCustomerBasketOffersData(treasuryData?.basketOffers);

  return treasuryNormalizedData.map((item) => ({
    ...baseNormalization(item),
    type: treasuryData.marketTypeTranslated || messageError,
    title: item.offer.productDisplay,
    productCategory:
      item.offer.productCategory || item.offer.category || item.offer.titleType || 'Tesouro Direto',
    details:
      item.operationType === 'buy'
        ? getDirectTreasuryBuyingDetails(item)
        : getDirectTreasurySellingDetails(item),
    total: {
      label: item.operationType === 'buy' ? 'Valor da aplicação' : 'Valor estimado do resgate',
      description: item.operationType === 'buy' ? '' : 'Valor liquido',
      value: item.requestedAmountFormatted,
    },
  }));
};
